export const API_CONFIG = {
  baseURL: 'https://gate.shjinjia.com.cn',
  defaultHeaders: {
    'Content-Type': 'application/json',
    'Accept': 'application/json, text/plain, */*',
  },
  endpoints: {
    searchTool: '/api/SearchTool/ExecuteSearchToolInstance',
    token: '/connect/token'
  }
};

// Token刷新配置
export const TOKEN_CONFIG = {
  REFRESH_DEBOUNCE: 30000, // 30秒内不重复刷新
  EXPIRE_THRESHOLD: 600 // token过期前10分钟开始刷新
};

// API响应码配置
export const API_STATUS_CODES = {
  SUCCESS: '0000',
  UNAUTHORIZED: '2000',
  FORBIDDEN: '2001'
};

// 存储键名配置
export const STORAGE_KEYS = {
  ACCESS_TOKEN: 'access_token',
  TOKEN_OBJ: 'tokenObj',
  SESSION_ID: 'J-Session-ID',
  MOCK_TOKEN: 'mock_token'
}; 